const SESSION_STATUS = {
  InActive: 0,
  Active: 1,
  Completed: 2,
};

export default SESSION_STATUS;
